import { ModalBody } from 'reactstrap';
import styled from 'styled-components';

export const ModalIcon = styled.img`
  width: 64px;
  height: 64px;
`;

export const ModalTitle = styled.h3`
  color: #000000;
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0 16px;
  font-family: Montserrat;
  line-height: 1;
`;

export const ModalBodyContainer = styled(ModalBody)`
  padding: 12px 40px 42px;
`;

export const ModalDescription = styled.p`
  color: #666666;
  font-family: Montserrat;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 20px;
  margin-top: 8px;
`;

export const ModalReasonsContainer = styled.div`
  background-color: #f4f4f4;
  padding: 16px;
  border-radius: 5px;
  color: #666666;
  font-family: Montserrat;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0%;
`;

export const ModalReasonsList = styled.ul`
  margin: 8px 0 0 0;
  padding-left: 20px;

  li {
    margin-bottom: 4px;
    color: #666666;
    font-family: Montserrat;
    font-weight: 400;
    font-style: normal;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0%;
  }
`;
